import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAppMode } from '@store/global/selectors';
import { AppModeEnum } from '@project-types/enums';
import Title from '@layouts/toolbar/title/Title';
import Menu from '@layouts/toolbar/menu/Menu';
import Search from '@layouts/toolbar/search/Search';
import User from '@layouts/toolbar/user/User';
import useIsSmallScreen from '@hooks/element-size-hooks/useIsSmallScreen';



const Toolbar = () => {

	const appMode = useSelector(selectAppMode);
	const isSmallScreen = useIsSmallScreen();
	const successInit = appMode === AppModeEnum.appSuccess;
	const [ searchIsOpen, setSearchIsOpen ] = useState(false);

	return (
		<div className='layout-toolbar'>
			
			<Title
				successInit={successInit}
				searchIsOpen={searchIsOpen} />

			{successInit && !isSmallScreen &&
				<Menu />}

			{successInit &&
				<Search
					isSmallScreen={isSmallScreen}
					searchIsOpen={searchIsOpen}
					setSearchIsOpen={setSearchIsOpen} />}
			
			{successInit &&
				<User />}
			
		</div>
	);
}

export default Toolbar;